import { makeStyles, shorthands } from '@fluentui/react-components';

export const useControlStyles = makeStyles({
  root: {
    position: 'relative',
    width: '100%',
    ...shorthands.overflow('hidden'),
    top: '-5px',
    backgroundColor: 'rgba(0,0,0,0.75)',

    '& .ms-Button svg': {
      width: '100%',
    },
    '& .ms-Button:focus': {
      ...shorthands.border('1px solid #fff'),
    },
    '& .ms-Button:hover': {
      backgroundColor: 'transparent',
    },
  },
  videoContainer: {
    paddingBottom: '32px',
  },
  sliderContainer: {
    width: '100%',
  },
  previewVideo: {
    width: '100%',
    maxHeight: '100%',
  },
  container: {
    display: 'flex',
    alignItems: 'center',

    '& i': {
      width: '100%',
      cursor: 'pointer',
    },
  },
});

const commonParentStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  height: '100%',
};

const iconCommonStyles = {
  fontSize: '36px',
  lineHeight: '36px',
  color: '#0078d4',
};

export const usePlaceholderStyle = makeStyles({
  encoding: {
    ...commonParentStyles,
    '& .placeholder-icon': {
      ...iconCommonStyles,
      animationName: [
        {
          to: {
            transform: 'rotate(360deg)',
          },
        },
      ],
      animationDuration: '1.2s',
      animationTimingFunction: 'linear',
      animationIterationCount: 'infinite',
    },
    '& .add-video-content-container': {
      marginTop: '14px',
    },
  },
  unverified: {
    ...commonParentStyles,
    '& .download-icon-container': {
      ...shorthands.overflow('hidden'),
      ...shorthands.borderBottom('2px solid #0078d4'),
    },
    '& .placeholder-icon': {
      ...iconCommonStyles,
      animationName: [
        {
          from: {
            transform: 'translateY(-18px)',
          },
          to: {
            transform: 'translateY(42px)',
          },
        },
      ],
      animationDuration: '1.2s',
      animationTimingFunction: 'ease',
      animationIterationCount: 'infinite',
    },
  },
  failed: {
    ...commonParentStyles,
    '& .placeholder-icon': {
      ...iconCommonStyles,
      color: '#d83b01',
    },
  },
});
